"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPodcastSeasonRefProperty = exports.podcastSeasonRefPropertyDefinition = void 0;
exports.podcastSeasonRefPropertyDefinition = {
    view: {
        label: 'Podcast seasons',
        readonly: true,
        hint: 'Read-only. Please navigate to the content you\'d want to remove or add in order to make changes.',
    },
    constraints: [
        {
            name: 'stencils',
            argument: ['podcast-season'],
        },
    ],
    type: 'child-ref',
    multiple: true,
    name: 'podcast-season-ref',
};
const isPodcastSeasonRefProperty = (prop) => {
    return prop.name === exports.podcastSeasonRefPropertyDefinition.name;
};
exports.isPodcastSeasonRefProperty = isPodcastSeasonRefProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicG9kY2FzdC1zZWFzb24tcmVmLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvcG9kY2FzdC1zZWFzb24tcmVmLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsa0NBQWtDLEdBQUc7SUFDaEQsSUFBSSxFQUFFO1FBQ0osS0FBSyxFQUFFLGlCQUFpQjtRQUN4QixRQUFRLEVBQUUsSUFBSTtRQUNkLElBQUksRUFBRSxrR0FBa0c7S0FDekc7SUFDRCxXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxVQUFVO1lBQ2hCLFFBQVEsRUFBRSxDQUFDLGdCQUFnQixDQUFDO1NBQzdCO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsV0FBVztJQUNqQixRQUFRLEVBQUUsSUFBSTtJQUNkLElBQUksRUFBRSxvQkFBb0I7Q0FDSyxDQUFBO0FBSTFCLE1BQU0sMEJBQTBCLEdBQUcsQ0FBQyxJQUFrQixFQUFvQyxFQUFFO0lBQ2pHLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSywwQ0FBa0MsQ0FBQyxJQUFJLENBQUE7QUFDOUQsQ0FBQyxDQUFBO0FBRlksUUFBQSwwQkFBMEIsOEJBRXRDIn0=